// extracted by mini-css-extract-plugin
export default {"letters":"letters_letters__+TRzn","letters__item":"letters_letters__item__cPQKC"};